module.exports = __webpack_public_path__ + "img/3.c2689e18.png";